var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudioDisplay = function SvgStudioDisplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.75 17.25h-4a2 2 0 0 1-2-2v-8.5a2 2 0 0 1 2-2h14.5a2 2 0 0 1 2 2v8.5a2 2 0 0 1-2 2h-4m-6.5 0v3h6.5v-3m-6.5 0h6.5"
  })));
};
export default SvgStudioDisplay;